/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

export const FETCH_VITALSOURCE_PUBLISH_SUCCESS = 'FETCH_VITALSOURCE_PUBLISH_SUCCESS';
export const FETCH_VITALSOURCE_BOOK_SUCCESS = 'FETCH_VITALSOURCE_BOOK_SUCCESS';
export const FETCH_VITALSOURCE_COLLECTION_SUCCESS = 'FETCH_VITALSOURCE_COLLECTION_SUCCESS';
export const UPDATE_VITALSOURCE_SUBSCRIPTION_LENGTH = 'UPDATE_VITALSOURCE_SUBSCRIPTION_LENGTH';
export const UPDATE_VITALSOURCE_BOOK_AVAILABILITY = 'UPDATE_VITALSOURCE_BOOK_AVAILABILITY';


export function fetchVitalsourceStatusSuccess(payload) {
    return {type: FETCH_VITALSOURCE_PUBLISH_SUCCESS, payload: payload};
}
export function fetchVitalsourceBookStatusSuccess(payload) {
    return {type: FETCH_VITALSOURCE_BOOK_SUCCESS, payload: payload};
}

export function setVitalsourceSubscriptionLength(payload) {
    return {type: UPDATE_VITALSOURCE_SUBSCRIPTION_LENGTH, payload: payload};
}

export function setVSbookAvailabilityInStoreSuccess(payload) {
    return {type: UPDATE_VITALSOURCE_BOOK_AVAILABILITY, payload: payload};
}

export function fetchVitalsourceCollectionSuccess(payload) {
    return {type: FETCH_VITALSOURCE_COLLECTION_SUCCESS, payload: payload};
}


// WEBPACK FOOTER //
// ./src/_actions/vitalsource.publish.action.js